<template>
  <div class="icu-icon" :class="iconName" @click="$emit('click')"></div>
</template>

<script>
export default {
  name: 'IcuIcon',
  props: {
    iconName: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/common/IcuIcon.scss";
</style>
